import { Component, OnInit } from '@angular/core';


interface IContactData {
  place: string, phoneInfo: string, email: string
}

@Component({
  selector: 'app-boton-contacto',
  templateUrl: './boton-contacto.component.html',
  styleUrls: ['./boton-contacto.component.scss']
})
export class BotonContactoComponent implements OnInit {

  constructor() { }

  togglePopUp = false;
  email = 'johanna.trivino@covinoc.com';
  phoneNumber = '3014489535';
  /**
   * email = 'monica.feinauer@covinoc.com';
  phoneNumber = '(1) 633 88 88';
   */

  public contactData: IContactData[] = [
    { place: 'Regional Cali: ', phoneInfo: '(062) 3808901 Ext. 3250', email: 'covirecupera.cali@covinoc.com' },
    { place: 'Regional Medellín: ', phoneInfo: '(064) 2836824', email: 'covirecupera.medellin@covinoc.com' },
    { place: 'Regional Caribe: ', phoneInfo: '(065) 3110110', email: 'cobranzasectorreal@covinoc.com' },
    { place: 'Resto del País: ', phoneInfo: '(601) 3813533', email: 'covirecupera.cobranzas@covinoc.com' },
  ]

  //   Para más información comuníquese en:
  // Regional Cali: (062) 3808901 Ext. 3250 / covirecupera.cali@covinoc.com 
  // Regional Medellín: (064) 2836824 / covirecupera.medellin@covinoc.com 
  // Regional Caribe: (065) 3110110 / cobranzasectorreal@covinoc.com
  // Resto del País: (601) 3813533 / covirecupera.cobranzas@covinoc.com

  ngOnInit() {
  }

  handleTogglePopUp() {
    this.togglePopUp = !this.togglePopUp;
  }

}
